// Detect page type
var isVariantPage = !!document.querySelector('.single-product.e-gift-cards');
var isGiftCardPage = !!document.querySelector('.product-type-gift-card');
var isEgiftPage = isVariantPage || isGiftCardPage;

// ============================================================
// WRAP gallery + summary in a grid container (all non-variant product pages)
// ============================================================
(function() {
    // Skip variant page — it has its own grid in the PHP template
    if (isVariantPage) return;

    // Find product container (gift-card or simple product)
    var product = document.querySelector('.product-type-gift-card') || document.querySelector('.product-type-simple');
    if (product) {
        var gallery = product.querySelector('.woocommerce-product-gallery');
        var summary = product.querySelector('.entry-summary');
        if (gallery && summary) {
            var wrapper = document.createElement('div');
            wrapper.className = 'egift-layout grid lg:grid-cols-2 gap-10';
            product.insertBefore(wrapper, gallery);
            wrapper.appendChild(gallery);
            wrapper.appendChild(summary);
        }
    }
})();

// ============================================================
// SHARED: Runs on both variant e-card AND standard e-gift pages
// ============================================================
if (isEgiftPage) {

    // Remove .00 from amount button labels
    document.querySelectorAll('.ywgc-predefined-amount-button.ywgc-amount-buttons bdi').forEach(function(el) {
        if (el.textContent.includes('.00')) {
            el.textContent = el.textContent.replace('.00', '');
        }
    });

    // Convert qty input to text and restrict to numbers
    var qtyInput = document.querySelector('.gift_card_template_button .quantity .qty');
    if (qtyInput) {
        qtyInput.setAttribute('type', 'text');
        qtyInput.setAttribute('pattern', '[0-9]*');
        qtyInput.setAttribute('inputmode', 'numeric');
        qtyInput.addEventListener('input', function () {
            this.value = this.value.replace(/[^0-9]/g, '');
        });
    }

    // Add +/- quantity buttons
    var qtyContainer = document.querySelector('.gift_card_template_button .quantity');
    if (qtyContainer) {
        var qtyField = qtyContainer.querySelector('.qty');
        if (qtyField) {
            var minusBtn = document.createElement('button');
            minusBtn.type = 'button';
            minusBtn.className = 'qty-btn qty-minus';
            minusBtn.textContent = '−';
            minusBtn.setAttribute('aria-label', 'Decrease quantity');

            var plusBtn = document.createElement('button');
            plusBtn.type = 'button';
            plusBtn.className = 'qty-btn qty-plus';
            plusBtn.textContent = '+';
            plusBtn.setAttribute('aria-label', 'Increase quantity');

            qtyContainer.insertBefore(minusBtn, qtyField);
            qtyContainer.appendChild(plusBtn);

            minusBtn.addEventListener('click', function () {
                var val = parseInt(qtyField.value) || 1;
                var min = parseInt(qtyField.getAttribute('min')) || 1;
                if (val > min) qtyField.value = val - 1;
            });

            plusBtn.addEventListener('click', function () {
                var val = parseInt(qtyField.value) || 1;
                var max = parseInt(qtyField.getAttribute('max')) || 999;
                if (val < max) qtyField.value = val + 1;
            });
        }
    }

    // Ensure dynamically added recipient fields always have placeholders
    function fixRecipientPlaceholders() {
        document.querySelectorAll('input[name="ywgc-recipient-name[]"]').forEach(function (input) {
            if (!input.placeholder) input.placeholder = "Recipient's name";
        });
        document.querySelectorAll('input[name="ywgc-recipient-email[]"]').forEach(function (input) {
            if (!input.placeholder) input.placeholder = "Recipient's email";
        });
    }

    var recipientContainer = document.querySelector('.gift-card-content-editor');
    if (recipientContainer) {
        var observer = new MutationObserver(fixRecipientPlaceholders);
        observer.observe(recipientContainer, { childList: true, subtree: true });
    }

    // Custom multiple recipient note
    if (typeof ywgc_data !== 'undefined') {
        ywgc_data.multiple_recipient = '<b>Note</b>: You added more than one recipient, so <i class="ywgc-darkred-text">you will buy %number_gift_cards% gift cards</i> and each recipient will receive a separate e-card.';
    }
}

// ============================================================
// VARIANT ONLY: Email preview, design selection, form validation
// ============================================================
if (isVariantPage) {

    // Toggle email preview
    document.getElementById('preview-email-btn').addEventListener('click', function () {
        var preview = document.getElementById('email-preview');
        document.body.classList.add('overflow-hidden');
        document.documentElement.classList.add('overflow-hidden');
        updateEmailPreview();
        preview.classList.toggle('active');
    });

    // Close email preview
    document.getElementById('close-email-preview').addEventListener('click', function () {
        var preview = document.getElementById('email-preview');
        document.body.classList.remove('overflow-hidden');
        document.documentElement.classList.remove('overflow-hidden');
        preview.classList.remove('active');
    });

    // Close on Escape
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            var preview = document.getElementById('email-preview');
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
            preview.classList.remove('active');
        }
    });

    // Close on outside click
    document.addEventListener('click', function (event) {
        var preview = document.getElementById('email-preview');
        if (event.target === preview) {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
            preview.classList.remove('active');
        }
    });

    // Design variant selection
    document.querySelectorAll('.variant-option').forEach(function (button) {
        button.addEventListener('click', function () {
            document.querySelectorAll('.variant-option').forEach(function (b) { b.classList.remove('selected'); });
            this.classList.add('selected');

            var selectedDesign = this.getAttribute('data-design-name');
            var selectedDesignImage = this.getAttribute('data-image-url');
            document.getElementById('selected_design').value = selectedDesign;
            document.getElementById('selected_design_image').value = selectedDesignImage;

            var productImage = document.getElementById('product-image');
            productImage.src = selectedDesignImage;
            productImage.alt = selectedDesign;

            document.getElementById('email-image-preview').src = selectedDesignImage;
        });
    });

    // Click product image to open preview
    document.getElementById('product-image').addEventListener('click', function () {
        document.getElementById('preview-email-btn').click();
    });

    // Auto-select first design on load
    document.addEventListener('DOMContentLoaded', function () {
        var firstDesign = document.querySelector('.variant-option');
        if (firstDesign) firstDesign.click();
    });

    // Update email preview content
    function updateEmailPreview() {
        var senderName = document.querySelector('#ywgc-sender-name') ? document.querySelector('#ywgc-sender-name').value : '';
        var message = document.querySelector('#ywgc-edit-message') ? document.querySelector('#ywgc-edit-message').value : '';
        var recipientName = document.querySelector('input[name="ywgc-recipient-name[]"]') ? document.querySelector('input[name="ywgc-recipient-name[]"]').value : '';
        var selectedDesignImage = document.querySelector('#product-image') ? document.querySelector('#product-image').src : '';

        document.getElementById('email-image-preview').src = selectedDesignImage;
        document.getElementById('email-message-preview').textContent = message;
        document.getElementById('from_name').textContent = senderName;
        document.getElementById('recipient_name').textContent = recipientName;
    }

    // Validate fields before submit
    function validateFields() {
        var senderName = document.getElementById('ywgc-sender-name').value;
        var message = document.getElementById('ywgc-edit-message').value;
        var selectedDesignElement = document.getElementById('selected_design');
        var selectedDesign = selectedDesignElement ? selectedDesignElement.value : '';
        var deliveryDate = document.getElementById('ywgc-delivery-date').value;

        document.getElementById('ywgc-sender-name').classList.remove('error');
        document.getElementById('ywgc-edit-message').classList.remove('error');
        document.getElementById('ywgc-delivery-date').classList.remove('error');

        if (!senderName) document.getElementById('ywgc-sender-name').classList.add('error');
        if (!message) document.getElementById('ywgc-edit-message').classList.add('error');
        if (selectedDesignElement && !selectedDesign) alert('Please select a design');

        if (deliveryDate) {
            var today = new Date();
            var selectedDate = new Date(deliveryDate);
            if (selectedDate < today) {
                document.getElementById('ywgc-delivery-date').classList.add('error');
                alert('Delivery date cannot be in the past');
                return false;
            }
        }

        return !!(senderName && message && (!selectedDesignElement || selectedDesign));
    }

    // Form submission with validation
    document.querySelector('.single-product.e-gift-cards form.cart').addEventListener('submit', function (event) {
        event.preventDefault();
        if (validateFields()) this.submit();
    });
}
